import circles from 'assets/images/circles.png';
import dialogIcon from 'assets/images/dialogLogo.svg';
import exploreImg from 'assets/images/exploreImg.svg';
import { Button, Input } from 'components/atoms';
import { useLogin } from 'framework/api/methods';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const Login = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  localStorage.clear();

  const { mutate: loginMutate, isLoading: checkUsertIsLoading } = useLogin();

  // function to login
  const handleLogin = () => {
    loginMutate(
      {
        username: formData?.username,
        password: formData?.password,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          localStorage.setItem('token', successData?.token);
          navigate('/');
        },
        onError: ({ response: { data: errData } }: any) => {
          notify('Login failed. Please try again', 'error');
        },
      },
    );
  };

  return (
    <div className="flex w-full h-full overflow-hidden relative">
      <div className="w-[55%] relative backdrop-welcome  justify-center items-center text-white hidden lg:flex flex-col gap-y-5">
        <div className="flex tracking-[20px] text-[3rem] font-light text-white text-shadow">
          WELCOME
        </div>

        <img src={exploreImg} alt="welcome-img" className="w-[300px] h-[300px] z-[2]" />

        <div className="flex flex-col justify-center items-center z-[2]">
          <img src={dialogIcon} alt="dialog-icon" className="w-[100px]" />
          <div className="font-light text-xl text-white w-[70%] text-center">
            Welcome to the Dialog 3D 360 VR video platform
          </div>
        </div>
        <img src={circles} alt="welcome-img" className="w-[120px] absolute bottom-4 left-4 z-[1]" />
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault(); // prevent page reload
          handleLogin(); // trigger login
        }}
        className="lg:rounded-l-[50px] lg:w-[50%] w-full border absolute h-full right-0 bg-[white] flex flex-col justify-center items-center"
      >
        <div className="flex text-[50px] font-light text-[#C40D42] text-center justify-center items-center w-full">
          LOGIN
        </div>
        <div className="w-1/2 flex flex-col pt-5 gap-y-2">
          <Input
            icon="ri-mail-line"
            placeholder="Email"
            appearance="gray"
            value={formData.username}
            onChange={(e: any) => {
              setFormData({
                ...formData,
                username: e.target.value,
              });
            }}
          />
          <Input
            icon="ri-lock-password-line"
            placeholder="Password"
            appearance="gray"
            value={formData.password}
            onChange={(e: any) => {
              setFormData({
                ...formData,
                password: e.target.value,
              });
            }}
            type="password"
          />
        </div>

        <Button
          type="submit"
          isRounded
          className="mt-5 !px-10"
          size="md"
          disabled={!(formData?.username && formData.password)}
          isLoading={checkUsertIsLoading}
          onClick={() => {
            handleLogin();
          }}
        >
          Login
        </Button>
      </form>
    </div>
  );
};

export default Login;
